import {
  Button,
  Card,
  Flex,
  Image,
  Markdown,
  useUiKitComponents,
} from "@qws-org/ui-kit";
import type { FC } from "react";

import type { CardGalleryCardGalleryItems } from "~/core";
import { isExternalLink, isInternalLink } from "~/core/utils/action.utils";

import type { CardGalleryProps } from "../CardGallery";

export type RowCardProps = Omit<CardGalleryProps, "data"> & {
  card?: CardGalleryCardGalleryItems;
};
export const RowCard: FC<RowCardProps> = (props) => {
  const {
    card: data,
    getImageUrl,
    getUrl,
    isControlInactive,
    onCallAction,
  } = props;
  const { Link } = useUiKitComponents();
  const controlAction = data?.card_gallery_items_id?.button_action;
  const isInactive = controlAction ? isControlInactive(controlAction) : true;
  const action = data?.card_gallery_items_id?.button_action?.action?.[0];
  let href;
  if (isExternalLink(action?.item)) {
    href = action.item.href ?? undefined;
  }
  if (isInternalLink(action?.item)) {
    href = action.item.page ? getUrl(action.item.page) : undefined;
  }
  const handlePressButton = (): void => {
    if (controlAction) {
      onCallAction(controlAction);
    }
  };

  return (
    <Card variant="primary" width="max-content">
      <Flex flexDirection="column" className="flex-grow" maxWidth={400}>
        <Link href={href}>
          <Image
            value={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",
              height: 205,
            })}
            mdValue={getImageUrl(data?.card_gallery_items_id?.image?.id ?? "", {
              format: "webp",

              height: 250,
            })}
            className="rounded-t-lg overflow-hidden"
            display="block"
            height="fit-content"
          />
        </Link>

        {data?.card_gallery_items_id?.text && (
          <Flex
            height="auto"
            className="flex-grow  "
            p={{ py: 24 }}
            md={{ p: 32 }}
          >
            <Markdown>{data.card_gallery_items_id.text}</Markdown>
          </Flex>
        )}
        {!isInactive && (
          <Flex justify="end" flexDirection="column" m={{ mt: "auto", mb: 24 }}>
            <Button
              href={href}
              fontWeight="mobile.bold"
              size="small"
              onPress={handlePressButton}
              p={{ py: 12, px: 24 }}
              md={{ m: { mx: 32 }, p: { px: 24, py: 12 } }}
              m={{ mb: 6 }}
              width="max-content"
              height="fit-content"
            >
              {data?.card_gallery_items_id?.button_text}
            </Button>
          </Flex>
        )}
      </Flex>
    </Card>
  );
};
